function GlobalConfig () {
  this._enableLogging = process.env.VUE_APP_ENABLE_LOGGING || process.env.NODE_ENV !== 'production' //Has To Be First For Logging

  let currentHost = window.location.host
  let baseUrl = currentHost
  let appUrl = currentHost
  let apiUrl = currentHost
  let splitDomain = currentHost.split('.')
  let subDomain = splitDomain.shift();

  if (subDomain === 'ui' || subDomain === 'agents') {
    appUrl = 'agents.' + splitDomain.join('.');
    baseUrl = 'ui.' + splitDomain.join('.');
    apiUrl = 'api.' + splitDomain.join('.');
  } else if (subDomain.indexOf('-') === -1) {
    apiUrl = subDomain + '-api.' + splitDomain.join('.')
    baseUrl = subDomain + '-ui.' + splitDomain.join('.')
  } else if (subDomain.indexOf('-') > 1 && subDomain.indexOf('-ui') === -1) {
    apiUrl = subDomain + '-api.' + splitDomain.join('.')
    baseUrl = subDomain + '-ui.' + splitDomain.join('.')
  } else {
    appUrl = appUrl.replace('-ui', '')
    apiUrl = apiUrl.replace('-ui', '-api')
  }

  if (process.env.VUE_APP_URL) {
    appUrl = process.env.VUE_APP_URL
  }

  if (process.env.VUE_APP_API) {
    apiUrl = process.env.VUE_APP_API
  }

  if (process.env.VUE_APP_BASE_URL) {
    baseUrl = process.env.VUE_APP_BASE_URL
  }

  if (process.env.VUE_APP_HEAP_ENABLED === 'true') {
    this._enableHeap = true
    this._appcuesAppId = process.env.VUE_APP_HEAP_APPCUES_APP_ID || 0
    this._heapAppId = process.env.VUE_APP_HEAP_APP_ID || 0
  } else {
    this._enableHeap = false
    this._appcuesAppId = 0
    this._heapAppId = 0
  }

  this.logMessage('GlobalConfig - Computed', appUrl, apiUrl, baseUrl)

  this.appUrl = this.prepUrl(appUrl)
  this._apiUrl = this.prepUrl(apiUrl)
  this.baseUrl = this.prepUrl(baseUrl)
  this._enforceLogin = process.env.VUE_ENFORCE_LOGIN || true

  this.logMessage('GlobalConfig', this.appUrl, this._apiUrl, this.baseUrl, process.env)

  this.configData = {
    'local_storage_ttl' : (36000000) //Ten Hours
  }
}

GlobalConfig.prototype.logMessage = function () {
  if (this.loggingEnabled()) {
    console.log(...arguments)
  }
}

GlobalConfig.prototype.cleanUrl = function (url) {
  // Replace All '/' To Single Instance. Add Back In '://' (Converted From Before To ':/'
  return url.replace(/[/]+/g, '/').replace(/:\//, '://')
}

GlobalConfig.prototype.applicationUrl = function (url) {
  return this.cleanUrl(this.appUrl + '/' + url)
}

GlobalConfig.prototype.generateUrl = function (url) {
  return this.cleanUrl(this.baseUrl + '/' + url)
}

GlobalConfig.prototype.apiUrl = function (url) {
  return this.cleanUrl(this._apiUrl + '/' + url)
}

GlobalConfig.prototype.enforceLogin = function () {
  return this._enforceLogin
}

GlobalConfig.prototype.loggingEnabled = function () {
  return this._enableLogging;
}

GlobalConfig.prototype.heapEnabled = function () {
  return this._enableHeap;
}

GlobalConfig.prototype.appcuesAppId = function () {
  return this._appcuesAppId;
}

GlobalConfig.prototype.heapAppId = function () {
  return this._heapAppId;
}

GlobalConfig.prototype.prepUrl = function (url) {
  url = url.replace('https://', '').replace('http://', '')
  url = window.location.protocol + '//' + url
  url = url + '/'

  return this.cleanUrl(url)
}

GlobalConfig.prototype.get = function (propName) {
  return this.configData[propName] || null;
}

const configInstance = new GlobalConfig()

export default configInstance
